import { render, staticRenderFns } from "./ChatNavbar.vue?vue&type=template&id=6ede136b"
import script from "./ChatNavbar.vue?vue&type=script&lang=js"
export * from "./ChatNavbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports